import {
  ControlPopupContainer,
  ControlPopupContent,
  PopupMenu,
  PopupMenuItem,
} from './styles';
import { INITIAL_CONTROLS, useStore } from '../../../../store';
import { TrashSimple, X } from '@phosphor-icons/react';
import { TtsContext } from '../../../../contexts/TtsContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

interface PitchPopupProps {
  blockId: string;
}

export const PitchPopup = ({ blockId }: PitchPopupProps) => {
  const { updateBlockControl, blocks } = useStore();
  const { hideToolbox } = useContext(TtsContext);

  const { t } = useTranslation('myapps');

  const index = blocks.findIndex((b) => b.id === blockId);

  const handleChange = (selectedOption: string) => {
    if (blocks[index] && blocks[index].controls.pitch !== selectedOption) {
      updateBlockControl(blockId, 'pitch', selectedOption);
      hideToolbox();
    }
  };

  const options = [
    { value: 'default', label: t('TTS_EFFECT_OPTION_DEFAULT') },
    { value: 'x-low', label: t('TTS_EFFECT_OPTION_X_LOW') },
    { value: 'low', label: t('TTS_EFFECT_OPTION_LOW') },
    { value: 'medium', label: t('TTS_EFFECT_OPTION_MEDIUM') },
    { value: 'high', label: t('TTS_EFFECT_OPTION_HIGH') },
    { value: 'x-high', label: t('TTS_EFFECT_OPTION_X_HIGH') },
  ];

  return (
    <ControlPopupContainer>
      <ControlPopupContent>
        <PopupMenu>
          {options.map((option) => (
            <PopupMenuItem
              isSelected={blocks[index]?.controls?.pitch === option.value}
              key={crypto.randomUUID() + `pitch-options-` + option.value}
              onClick={() => handleChange(option.value)}
            >
              {option.label}
            </PopupMenuItem>
          ))}
        </PopupMenu>
      </ControlPopupContent>
      {blocks[index]?.controls.pitch !== 'default' && (
        <PopupMenuItem
          isSelected={false}
          onClick={() => handleChange({ ...INITIAL_CONTROLS }.pitch)}
          style={{ border: '1px solid #fd6262' }}
        >
          <X />
          Clear
        </PopupMenuItem>
      )}
    </ControlPopupContainer>
  );
};
